import {
  Box,
  Button,
  Collapse,
  CollapseHeader,
  CollapsePanel,
  Heading,
} from "@vinomofo/components";
import { PropsWithChildren, useState } from "react";

import { COLORS } from "../../../styles";
import styled from "styled-components";

const Container = styled(Box)`
  transition: color 0.3s ease-in-out;
`;

const MainHeading = styled(Heading)`
  width: 50%;
  margin-bottom: 15px;

  @media (max-width: 767px) {
    width: 100%;
  }
`;

const SubHeading = styled(Heading)`
  width: 50%;

  @media (max-width: 767px) {
    width: 100%;
  }
`;

const Quote = styled(Heading)`
  width: 50%;

  @media (max-width: 767px) {
    width: 100%;
  }
`;

export const SellBanner = (): JSX.Element => {
  return (
    <Container
      display="flex"
      flexDirection={["column", "column", "column"]}
      gridGap={["80px", "110px", "120px"]}
      width="100%"
      color="white"
      pb="150px"
      pt={["60px", "70px", "80px"]}
      fontFamily="DM Sans, sans-serif"
      position="relative"
    >
      <Box
        display="flex"
        flexDirection="column"
        gridGap="0"
        width={"100%"}
        mt={["25px", "25px", "0"]}
      >
        <MainHeading
          fontSize={[3, 4, 4]}
          color={COLORS.mofoGold}
          fontFamily="DM Sans, sans-serif"
          fontWeight="500"
          lineHeight="1.2"
          textTransform="uppercase"
        >
          We sell a dram every 13.2 seconds
        </MainHeading>
        <SubHeading
          fontSize={[10, 11, 11]}
          color="white"
          fontFamily="DM Sans, sans-serif"
          fontWeight="500"
          lineHeight="1.2"
        >
          Exclusive whiskies and spirits from the world’s best distilleries— at
          prices that’ll make you double-take. And yes, they’re <u>real</u>.
        </SubHeading>
      </Box>
      <Box
        display="flex"
        flexDirection="column"
        gridGap="0"
        width={"100%"}
        mt={["25px", "25px", "0"]}
        alignItems="end"
        textAlign="right"
      >
        <Quote
          fontSize={[3, 4, 4]}
          color="white"
          fontFamily="DM Sans, sans-serif"
          fontWeight="700"
          lineHeight="1.2"
        >
          We’re talking never-before-seen, jaw-dropping prices on premium,
          sought-after whiskies & spirits. These are the deals that will
          redefine the industry and your drinking experience.
        </Quote>
      </Box>
    </Container>
  );
};
